import React, { useState, useEffect, useRef, useCallback } from 'react';

import { 
  Character,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharacterRaceInput from "@dndComponents/character/race/CharacterRaceInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterSidekickCreatureInput from "@dndComponents/character/race/CharacterSidekickCreatureInput";

interface Props {
  char: Character;
  disabled: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterRaceButton({
  char,
  disabled,
}: Props) {
  const [open, setOpen] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [flashing, setFlashing] = useState(char.sidekick ? (char.sidekick_creature_id === "") : (char.spirit.race.source_id === "" || char.spirit.race.needs_attention));
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const modalClosed = useCallback(() => {
    console.log("Char Race Button - Modal Closed");
    setTimeout(() => {
      if (char.sidekick ? (char.sidekick_creature_id === "") : (char.spirit.race.source_id === "" || char.spirit.race.needs_attention)) {
        setFlashing(true);
      } else {
        setFlashing(false);
      }
    }, 100);
    setReloading(true);
  }, []);

  useEffect(() => {
    char.subscription_holder.subscribe("Modal Closed", mounted, modalClosed);
  }, [char, modalClosed]);


  const renderExtras = () => {
    const wide_mode = window.innerWidth > 800;
    return (
      <ModalOrDrawer 
        open={ open } 
        // drawer_only
        width={ wide_mode ? 800 : undefined }
        onClose={() => {
          setOpen(false); 
          char.subscription_holder.modalClosed();
        }}>
        { open &&
          <>
            { char.sidekick ?
              <CharacterSidekickCreatureInput
                char={char}
              />
            :
              <CharacterRaceInput
                char={char}
              />
            }
          </>
        }
      </ModalOrDrawer>
    );
  }

  const className = flashing ? "Flashing clickable" : "clickable";
  let race_name = char.sidekick ? (char.sidekick_creature ? char_util.getUseName(char.sidekick_creature) : "No Creature") : char.spirit.race.source ? char_util.getUseName(char.spirit.race) : "No Race";
  if (race_name === "No Race" && char.c_options.races_called === "Species") {
    race_name = "No Species";
  }
  return (
    <>
      <div style={{ fontSize: "16px" }}
        className={ disabled ? "" : className }
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        { race_name }
      </div>
      <div style={{ fontSize: "10px", color: "gray" }}
        className={ disabled ? "" : className }
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        { char.sidekick ? "Creature" : char.c_options.races_called }
      </div>
      <div style={{ fontSize: "10px", color: "gray" }}
        className={ disabled ? "" : className }
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        Creature Type: { char.creature_type }
      </div>
      { renderExtras() }
    </>
  ); 
}
